
const moveIndex = (input, currentSlide, maxLength) => {
  let nextIndex = 0;
  const currentIndex = parseInt(currentSlide.dataset.countSlide);
  if (input == "next") {
    nextIndex = currentIndex + 1; 
    if ( nextIndex > maxLength || maxLength == 0 ) {
      nextIndex = 0;
    }
  } else if (input == "prev") {
    nextIndex = currentIndex - 1;
    if (0 > nextIndex || maxLength == 0) {
      nextIndex = maxLength;
    }
  }
  return nextIndex;
}
// next slide es el array con el nextIndex
const moveSlide = (input, lastSlide, nextSlide) => {
  // display none to last Slide
  lastSlide.style.display = 'none';
  const movement = (input == 'next') ? 'animation-left' : 'animation-right' ;
  // slide.classList.remove('animation-left','animation-right');
  nextSlide.style.display = '';
  nextSlide.classList.add(movement);
  setTimeout(() => {
    nextSlide.classList.remove(movement);
  }, 800);
}
const changeCurrentSlide = (lastSlide, currentSlide) => {
  lastSlide.dataset.current = "false";
  currentSlide.dataset.current = "true";
}
const carouselClickHandler = (action, buttonId, slidesId) => {
  const slides = $(slidesId);
  const maxLength = slides.length - 1;
  $(buttonId).on("click", () => {
    let currentSlide; // conseguir el slide actual por data current
    slides.each(function(index,element) {
      if(element.dataset.current == "true") {
        currentSlide = element;
      }
    })
    const nextIndex = moveIndex(action, currentSlide, maxLength);
    moveSlide(action, currentSlide, slides[nextIndex]);
    changeCurrentSlide(currentSlide, slides[nextIndex]);
  }
  );
}



